import { Icon, PATH } from '../icons'
import type { QuickQaSuggestion } from './suggestions'

// 空狀態那一區的建議按鈕（#1365）。內容由後台維護，這裡只負責畫。
// 🔴 按下去只呼叫 onPick 把問句交出去，這個元件本身沒有送出的能力——
// 「只是帶入、不自動送出」因此不是靠約定，是這裡根本做不到送出。

export function SuggestionBar(
  { suggestions, disabled, onPick }: {
    suggestions: QuickQaSuggestion[]
    disabled: boolean
    onPick: (question: string) => void
  },
) {
  // 一則都沒有（後台還沒建、或端點取不到）就整區不出現，不留一塊空白
  if (suggestions.length === 0) return null
  return (
    <div className="suggestions">
      {suggestions.map(({ quickQaId, label, question }) => (
        <button
          key={quickQaId}
          className="suggestion"
          disabled={disabled}
          // 按鈕短、問句長，所以把完整問句掛在 title 上讓人先看得到要問什麼
          title={question}
          onClick={() => onPick(question)}
        >
          {label}
          <Icon d={PATH.arrowUpRight} size={15} />
        </button>
      ))}
    </div>
  )
}
